import { ActionTypes } from "../constants/action-types";

export const setNavigationParameter = (val) => {
  return {
    type: ActionTypes.SET_NAVIGATION_PARAMETER,
    payload: val,
  };
};
